import styled from 'styled-components';

export const Container = styled.div`
  --not-started-color: #959595;
  --loading-color: #ffffff;
  --success-color: #56d4c9;

  width: 18px;
  height: 18px;
  margin-right: 6px;
  border-radius: 1em;

  .sr-spinner {
    circle {
      stroke: var(--loading-color);
      stroke-dashoffset: 170;
      transform-origin: center center;
      animation: rotating 0.7s cubic-bezier(0.45, 0.19, 0.25, 0.61) infinite;
      transition: stroke-dashoffset 0.4s ease-in, stroke 0.6s ease-in;
    }

    path {
      stroke: green;
      stroke-dashoffset: 100;
    }

    circle, path {
      transform: translate3d(0, 0, 0);
    }

    &.not_started {
      path {
        stroke: var(--not-started-color);
        stroke-dashoffset: -60;
      }
      circle {
        stroke: var(--not-started-color);
        stroke-dashoffset: 0%;
      }
    }

    &.success {
      path {
        transition: stroke-dashoffset 1s linear 0.3s;
      }

      circle,
      path {
        stroke: var(--success-color);
        stroke-dashoffset: 0%;
      }
    }
  }

  @-webkit-keyframes rotating /* Safari and Chrome */
  {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
